import { reserves } from '@/services/axios';

export const exclusiveManagement = {
    namespaced: true,
    state: {
        data: {
            availability: {
                units: []
            },
            config: {
                active: false,
                has_view_units: false,
                has_view_value: false
            },
            filters: {
                blocks: [],
                floors: [],
                situations: [],
                stages: [],
                teams: []
            },
            pagination: {
                current_page: 1,
                find: 0,
                last_page: 1,
                per_page: 5,
                total: 0
            },
            situations: {},
            summary: []
        },
        configLimit: {
            data: {},
            msg: '',
            status: ''
        },
        selectedUnitsChecked: [],
        loadingList: false,
        configActiveData: {},
        hasSummary: false
    },

    getters: {
        getData: state => state?.data || {},

        getAvailability: state => state?.data?.availability || {},
        
        getSituations: state => state?.data?.situations || {},

        getLoadingList: state => state?.loadingList,

        getConfigLimit: state => state?.configLimit || {},

        getSelectedUnitsChecked: state => state?.selectedUnitsChecked || [],

        getConfigActiveData: state => state?.configActiveData || {},

        getHasSummary: state => state?.hasSummary
    },

    mutations: {
        SET_DATA(state, payload) {
            state.data = payload
        },

        SET_LOADING_LIST(state, payload) {
            state.loadingList = payload
        },

        SET_CONFIG_LIMIT(state, payload) {
            state.configLimit = payload
        },

        SET_SELECTED_CHECKED(state, payload) {
            if (!payload || payload.length === 0) {
                state.selectedUnitsChecked = []
                return
            }

            if (payload.checked && payload.situation !== 'sale') {
                state.selectedUnitsChecked = [
                    ...state.selectedUnitsChecked.filter(item => item.id !== payload.id),
                    payload
                ]
            } else {
                state.selectedUnitsChecked = state.selectedUnitsChecked.filter(item => item.id !== payload.id)
            }
        },

        SET_CONFIG_ACTIVE_DATA(state, payload) {
            if (payload.active == false) {
                state.data.summary = []
            }
            state.configActiveData = payload
        },

        SET_HAS_SUMMARY(state, payload) {
            state.hasSummary = payload
        },
        UPDATE_CONFIG(state, payload) {
            state.data.config.has_view_units = payload.has_view_units
            state.data.config.has_view_value = payload.has_view_value
        }
    },

    actions: {
        async listExclusiveUnits({ commit }, params) {
            const { data } = await reserves.getConfigLimitProduct(params.id, params.query)
            commit('SET_DATA', data.data)
        },

        async activateExclusiveUnits({ commit }, params) {
            commit('SET_CONFIG_ACTIVE_DATA', params)
            const { data } = await reserves.postConfigLimitProduct(params)
            commit('SET_CONFIG_LIMIT', data)
        },

        handleSelectedUnitsChecked({ commit }, checked) {
            commit('SET_SELECTED_CHECKED', checked)
        },

        handleHasSummary({ commit }, params) {
            commit('SET_HAS_SUMMARY', params)
        },

        handleSetLoadingList({ commit }, params) {
            commit('SET_LOADING_LIST', params)
        },
        updateConfigActiveData({ commit }, params) {
            commit('UPDATE_CONFIG', params)
        }
    }
}